// navigator.clipboard only exists in secure contexts (dev serves plain HTTP),
// so fall back to the textarea/execCommand trick AppLayout's debug bar uses.
export function copyText(text: string) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).catch(() => { /* ignored — copy is best-effort */ })
    return
  }
  const el = document.createElement('textarea')
  el.value = text
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}
